import { render, staticRenderFns } from "./VisitFaq.vue?vue&type=template&id=69785499&scoped=true"
import script from "./VisitFaq.vue?vue&type=script&lang=js"
export * from "./VisitFaq.vue?vue&type=script&lang=js"
import style0 from "./VisitFaq.vue?vue&type=style&index=0&id=69785499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69785499",
  null
  
)

export default component.exports